import { EntityDescription, TypeDescriptionService, Metadata, CurrentSession } from '../Api/interfaces';
import AuthenticationService from './AuthenticationService';
import { metadataUrl, flagParameter, typeParameter } from '../config';
import { doFetch } from '../Api/fetch';

export default class AuthenticatedDescriptionService implements TypeDescriptionService {
  private static instance: AuthenticatedDescriptionService;

  private metaData: Metadata;

  public async getDescriptor(typeName: string): Promise<EntityDescription> {

    const url = `${this.getMetadataUrl()}?${typeParameter}=${typeName}&${flagParameter}=relations,fields`;
    const meta = await this.doFetch(url, 'GET') as Metadata;
    return meta.entityDescriptions[0];
  }

  private getMetadataUrl(): string {
    const session = AuthenticationService.getSessionInfo();
    return session.apiUrl + metadataUrl;
  }

  public async getDescriptors(): Promise<EntityDescription[]> {
    const meta = await this.getMetadata();
    return meta.entityDescriptions;
  }

  public async getMetadata(): Promise<Metadata> {
    if (!this.metaData) {
      this.metaData = await this.doFetch(await this.getMetadataUrl(), 'GET') as Metadata;
    }
    return this.metaData;
  }

  public static getInstance(): AuthenticatedDescriptionService {
    if (!AuthenticatedDescriptionService.instance) {
      AuthenticatedDescriptionService.instance = new AuthenticatedDescriptionService();
    }
    return AuthenticatedDescriptionService.instance;
  }


  private doFetch = async (url: string, method: string) => {
    const session = AuthenticationService.getSessionInfo();
    const options: RequestInit = {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Session ${session.sessionId}`,
      },
    };

    try {
      return await doFetch(url, options);
    } catch (error) {
      if (error.status === 401) {
        AuthenticationService.cleanSessionInfo();
        return null;
      }
    }
  };
}
